<template>
  <div>
    <!-- Map Tools Start -->
    <div class="sd-tools--topleft">
      <!-- Check List Options -->
      <div class="d-flex flex-row" v-if="isCheckList && inspectionData" v-click-outside="hideCheckListOptions">
        <div
          class="sd-tools__boxes p-2 mb-2 sd-bg--white"
          @click="viewCheckListOptions = !viewCheckListOptions">
          <img src="@/assets/img/inspection.svg" width="25px">
        </div>

        <!-- CheckList Options -->
        <div class="sd-tools__checklistoptns sd-bg--white p-2" v-if="viewCheckListOptions" @click.stop>
          <!-- Heading -->
          <div class="p-2">
            Inspection Summary
          </div>
          <div class="sd-tools__scrollMenu">
          <form @submit.prevent="formSubmitted" ref="inspectionForm" class="p-2">
          <div v-for="(value,key) in inspectionData" :key="key">
            <div v-if="key.split('-')[0]==='category'" class="sd-font-sm">
              <span v-for="index in key.split('-')[1].split('_').length" :key="index">
                {{key.split('-')[1].split('_')[index-1]}}
              </span>
              <input type="text" :name="key" :value="value" style="display:none">
              <hr>
            </div>
            <div v-else-if="key.split('-')[0]==='text'">
              <div class="input-group input-group-sm mb-3">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    <span v-for="index in key.split('-')[1].split('_').length" :key="index">
                      {{key.split('-')[1].split('_')[index-1]}}&nbsp;
                    </span>
                  </div>
                </div>
                <input type="text" class="form-control" :name="key" :value="value">
              </div>
            </div>
            <div v-else-if="key.split('-')[0]==='boolean'">
              <div class="custom-control custom-checkbox dropdown-item remove-click-bg" @click.stop>
                <input
                  @click.stop
                  class="custom-control-input"
                  type="hidden"
                  :name="key"
                  value="no">
                <input
                  @click.stop
                  class="custom-control-input"
                  type="checkbox"
                  :name="key"
                  :id="key"
                  value="yes"
                  :checked="value==='yes'">
                <label class="custom-control-label sd-font-sm" :for="key" @click.stop>
                  <span v-for="index in key.split('-')[1].split('_').length" :key="index">
                    {{key.split('-')[1].split('_')[index-1]}}
                  </span>
                </label>
              </div>
            </div>
          </div>
          <input type="submit" class="btn btn-primary ml-0" value="Submit"/>
          </form>
          <div v-if="formSaveMessage">
            <p class="sd-font-sm text-primary">{{formSaveMessage}}</p>
          </div>
          </div>
        </div>
      </div>
      <!-- Map Filters -->
      <div class="d-flex flex-row">
        <div
          class="sd-tools__boxes p-2 mb-2 sd-bg--white"
          @click="viewMapFilterOptions = !viewMapFilterOptions"
          v-click-outside="hideMapFilterOptions">
          <img src="@/assets/img/mainmap/map_tools_filter.svg" width="25px">
        </div>
        <!-- Map Filters Options -->
        <div class="sd-tools__mapfilteroptns sd-bg--white p-2" v-if="viewMapFilterOptions" @click.stop>
          <!-- Heading -->
          <div class="p-2">
            Map Filters
          </div>
          <!--Assets Option -->
          <hr v-if='projectImages.length'>
          <div class="d-flex flex-row justify-content-between px-2 py-1" v-if='projectImages.length'>
            <div class="sd-font-sm">
              <img src="@/assets/img/mainmap/map_filter_assets.svg" class="pb-1 pr-1" alt="">
              Images
            </div>
            <div>
              <label class="sd-toggle">
                <input type="checkbox" :checked="isImagesVisible" @click.stop="imagesClickHandler">
                <span class="sd-toggle-slider round"></span>
              </label>
            </div>
          </div>
          <!-- Drone Pathways Option -->
          <hr v-if='projectVideos.length'>
          <div class="d-flex flex-row justify-content-between px-2 py-1" v-if='projectVideos.length'>
            <div class="sd-font-sm">
              <img src="@/assets/img/mainmap/map_filter_drone.jpg" class="pb-1 pr-1" width="16px" alt="">
              Drone Pathways
            </div>
            <div>
              <label class="sd-toggle">
                <input type="checkbox" :checked="isVideosVisible" @click.stop="videosClickHandler">
                <span class="sd-toggle-slider round"></span>
              </label>
            </div>
          </div>
          <!-- Comments Option -->
          <hr>
          <div class="d-flex flex-row justify-content-between px-2 py-1">
            <div class="sd-font-sm">
              <img src="@/assets/img/mainmap/map_filter_comments.svg" class="pb-1 pr-1" width="16px" alt="">
              Comments
            </div>
            <div>
              <label class="sd-toggle">
                <input type="checkbox" :checked="isCommentsVisible" @click.stop = "commentsClickHandler">
                <span class="sd-toggle-slider round"></span>
              </label>
            </div>
          </div>
          <!-- Ortho Layer Properties Option -->
          <hr v-if="isLayerOrtVisible && (layerDetails.length > 0)">
          <div class="p-2" v-if="isLayerOrtVisible && (layerDetails.length > 0)">
            <div class="sd-font-sm font-weight-bold mb-2">
              Ortho Layer Properties:
            </div>
            <div v-for="layer in layerDetails" :key="layer.id">
              <div class="custom-control custom-checkbox" @input="toggleLayerVisibility(layer.id)">
                <input
                  class="custom-control-input"
                  type="checkbox"
                  v-model="layer.isVisible"
                  :id="layer.id">
                <label class="custom-control-label sd-font-sm" :for="layer.id">
                  {{layer.layerName}}
                </label>
              </div>
              <div v-if="layer.vectorLayers.length >= 1">
                <div v-for="vector in layer.vectorLayers" :key="vector.id+layer.id">
                  <div class="custom-control custom-checkbox ml-3" @input="toggleVectorVisibility({layerId:layer.id, vectorId:vector.id})">
                    <input
                      class="custom-control-input"
                      type="checkbox"
                      v-model="vector.isVisible"
                      :id="vector.id+layer.id">
                    <label class="custom-control-label sd-font-sm" :for="vector.id+layer.id">
                      {{vector.name}}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Poi Option -->
          <!--
          <hr>
          <div class="d-flex flex-row justify-content-between px-2 py-1">
            <div class="sd-font-sm">
              <img src="@/assets/img/mainmap/map_filter_poi.svg" class="pb-1 pr-1" width="16px" alt="">
              Points of Interest
            </div>
            <div>
              <label class="sd-toggle">
                <input type="checkbox">
                <span class="sd-toggle-slider round"></span>
              </label>
            </div>
          </div>
          -->

          <!-- Opacity Option -->
          <!-- <div class="d-flex flex-row justify-content-between px-2 py-1">
            <div class="sd-font-sm">
              Opacity
            </div>
            <div class="font-weight-bold sd-font-sm">
              {{rangeValue}} %
            </div>
          </div>
          <input type="range" class="custom-range px-2" v-model="rangeValue">-->
        </div>
      </div>

      <div class="sd-tools__boxes p-2 mb-2 sd-bg--white" v-if='projectVideos.length'>
        <img @click="toggleVideoPlayer()" src="@/assets/img/mainmap/map_tools_video.svg" width="25px">
      </div>
      <div class="d-flex flex-row">
      <div
        class="sd-tools__boxes p-2 mb-2 sd-bg--white"
        @click="viewCommentAssetsMenu = !viewCommentAssetsMenu"
         v-click-outside="hideCommentAssetsMenu">
        <img src="@/assets/img/mainmap/map_tools_comments.svg" width="25px">
      </div>
      <!-- All Issue/Comment Assets -->
        <div class="sd-tools__commentAssetsMenu sd-bg--white p-2" v-if="viewCommentAssetsMenu" @click.stop>
          <!-- Heading -->
          <div class="row no-gutters">
            <div class="col-4">Issues</div> 
            <div class="col-3">
              <select class="form-control form-control-sm sd-font-xs p-0 border-0" v-model="filterPriority">
                <option value="null">Select Priority</option>
                <option value="high">High</option>
                <option value="medium">Medium</option>
                <option value="low">Low</option>
              </select>
            </div>
            <div class="col-5">
            <select class="form-control form-control-sm sd-font-xs p-0 border-0" v-model="filterCategory">
              <option value="null">Select Category</option>
              <option v-for="category in commentCategories" :key="category.id" :value="category.id">
                {{category.category}}
              </option>
            </select>
            </div>
          </div>
          <!--Assets Option -->
          <div class="sd-tools__scrollMenu">
            <div v-for="comment in commentsData" :key="comment.comment_id">
              <commentView
                v-if="filterComments(comment)"
                :comment='comment'
                :isDeleteEnabled='enableDeleteButton(comment)'
                >
              </commentView>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="sd-tools--bottomleft" v-if='!isSchematic && (projectDsms.length || projectLayers.length)'>
      <div class="d-flex flex-row">
      <div
        class="sd-tools__maplayer p-3 sd-bg--white"
        @click.stop="viewMapLayerOptions = !viewMapLayerOptions">
        <img src="@/assets/img/mainmap/map_tools_stack.svg" width="25px">
      </div>
      <!-- Map Layer Options Start -->
      <div class="d-flex flex-row" v-if="viewMapLayerOptions">
        <div
          class="sd-tools__maplayer ml-2 font-weight-bold"
          @click.stop="ortClickHandler"
          :class="{'sd-tools__ort': !isLayerOrtVisible, 'bg-primary': isLayerOrtVisible}">
          <div class="sd-tools__mlcontent">
            <!-- TODO: Update tick mark svg after getting proper asset from designer -->
            <div v-if="isLayerOrtVisible" class="text-center">
              <img src="@/assets/img/mainmap/map_layer_tick.svg" alt="" srcset="">
            </div>
            <div :class="{'text-light': isLayerOrtVisible}">Ort</div>
          </div>
        </div>
        <div
          class="sd-tools__maplayer ml-2 font-weight-bold"
          @click.stop="dsmClickHandler"
          v-if='projectDsms.length'
          :class="{'sd-tools__dsm': !isLayerDsmVisible, 'bg-primary': isLayerDsmVisible}">
          <div class="sd-tools__mlcontent">
            <div v-if="isLayerDsmVisible" class="text-center">
              <!-- TODO: Update tick mark svg after getting proper asset from designer -->
              <img src="@/assets/img/mainmap/map_layer_tick.svg" alt="" srcset="">
            </div>
            <div :class="{'text-light': isLayerDsmVisible}">ELEV</div>
          </div>
        </div>
        <div
          class="sd-tools__maplayer ml-2 font-weight-bold"
          @click.stop="drwClickHandler"
          v-if='false'
          :class="{'sd-tools__drw': !isLayerDrwVisible, 'bg-primary': isLayerDrwVisible}">
          <div class="sd-tools__mlcontent">
            <!-- TODO: Update tick mark svg after getting proper asset from designer -->
            <div v-if="isLayerDrwVisible" class="text-center">
              <img src="@/assets/img/mainmap/map_layer_tick.svg" alt="" srcset="">
            </div>
            <div :class="{'text-light': isLayerDrwVisible}">Drw</div>
          </div>
        </div>
      </div>
      <!-- Map Layer Options Start -->
      </div>
    </div>

    <!-- Bottom Right Tools: Comment On Map  -->
    <div class="sd-tools--bottomright"
      v-if='!isSchematic && showCommentOnMapTool'>
      <div
        class="sd-tools__circle"
        @click.stop="commentOnMapClickHandler"
        :class="{'sd-bg--white': !isCommentOnMapEnabled, 'sd-bg--black': isCommentOnMapEnabled}">
        <img src="@/assets/img/mainmap/map_tools_comments.svg" class="img-fluid">
      </div>
    </div>
    <!-- End: Bottom Right Tools: Comment On Map -->
    <!-- Map Tools End -->
  </div>
</template>

<script>
import * as vClickOutside from 'v-click-outside-x';
import api from '@/api';
import { mapMutations, mapState } from 'vuex';
import { USER_ROLES, POSITION_TIME_DATA_SETTERS } from '@/config';
import DateOperations from '@/mixins/DateOperations';
import commentView from '@/components/commentView.vue';

export default {
  props: ['sid'],
  data() {
    return {
      inspectionData: {},
      viewMapLayerOptions: false,
      viewCheckListOptions: false,
      viewCommentAssetsMenu: false,
      viewMapFilterOptions: false,
      rangeValue: 0,
      haveCommentsData: false,
      filterPriority: 'null',
      filterCategory: 'null',
      commentsData: [],
      isSchematic: false,
      isCheckList: false,
      formSaveMessage: '',
    };
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  mixins: [DateOperations],
  computed: {
    ...mapState([
      'commentDataWatch',
      'layerDetails',
      'isLayerOrtVisible',
      'isLayerDsmVisible',
      'isLayerDrwVisible',
      'isCommentsVisible',
      'isImagesVisible',
      'isVideosVisible',
      'isCommentOnMapEnabled',
      'isVideoPlayerVisible',
      'auth',
      'commentCategories',
      'commentsDataCache',
      'currentProject',
      'projectVideos',
      'projectDsms',
      'projectLayers',
      'projectImages',
      'showCommentOnMapTool',
    ]),
  },
  components: {
    commentView,
  },
  watch: {
    commentDataWatch() {
      this.commentsData = [];
      for (let dataId in this.commentsDataCache) {
        Array.from(this.commentsDataCache[dataId]).forEach((comment) => {
          this.commentsData.push(comment);
        })
      }
    },
    filterPriority() {
      this.haveCommentsData = false;
      this.haveCommentsData = true;
    },
    filterCategory() {
      this.haveCommentsData = false;
      this.haveCommentsData = true;
    },
    sid() {
      this.formSaveMessage = '';
      Array.from(this.currentProject.subsections).forEach((subsection) => {
        if(subsection.subsection_id === Number(this.sid)) {
          this.inspectionData = subsection.checklist_json;
        }
      });
    },
    currentProject() {
      Array.from(this.currentProject.project_features).forEach((feat) => {
        if (feat.feature_name == 'isSchematicOrtho' && feat.enabled) {
          this.isSchematic = true;
        } else if (feat.feature_name == 'isCheckList' && feat.enabled) {
          this.isCheckList = true;
          Array.from(this.currentProject.subsections).forEach((subsection) => {
            if(subsection.subsection_id === Number(this.sid)) {
              this.inspectionData = subsection.checklist_json;
            }
          });
        }
      })
    }
  },
  methods: {
    ...mapMutations([
      'toggleOrtVisibility',
      'toggleDsmVisibility',
      'toggleDrwVisibility',
      'toggleCommentsVisibility',
      'toggleCommentOnMap',
      'toggleImagesVisiblilty',
      'toggleVideosVisibility',
      'setVideoPlayerVisibility',
      'toggleLayerVisibility',
      'toggleVectorVisibility',
    ]),
    ortClickHandler() {
      this.toggleOrtVisibility(!this.isLayerOrtVisible);
    },
    dsmClickHandler() {
      this.toggleDsmVisibility(!this.isLayerDsmVisible);
    },
    drwClickHandler() {
      this.toggleDrwVisibility(!this.isLayerDrwVisible);
    },
    commentsClickHandler() {
      this.toggleCommentsVisibility(!this.isCommentsVisible);
    },
    imagesClickHandler() {
      this.toggleImagesVisiblilty(!this.isImagesVisible);
    },
    videosClickHandler() {
      this.toggleVideosVisibility(!this.isVideosVisible);
    },
    commentOnMapClickHandler() {
      this.toggleCommentOnMap(!this.isCommentOnMapEnabled);
    },
    toggleVideoPlayer() {
      if (this.isVideoPlayerVisible) {
        this.$root.$emit('pausevideo');
        this.setVideoPlayerVisibility(false);
      } else {
        this.$root.$emit('playvideo');
      }
    },
    enableDeleteButton(comment) {
      if (this.auth.role === USER_ROLES.ADMIN) {
        return true;
      } else if (this.auth.user_id === comment.user) {
          return true;
      }

      return false;
    },
    filterComments(comment) {
      if (this.filterPriority =='null' && this.filterCategory=='null') {
        return true;
      } else if( (this.filterPriority == 'null' || this.filterPriority == comment.priority) &&
       (this.filterCategory == 'null' || this.filterCategory == comment.category) ) {
        return true;
      } else {
        return false;
      }
    },

    hideMapFilterOptions() {
      this.viewMapFilterOptions = false;
    },

    hideCheckListOptions() {
      this.viewCheckListOptions = false;
    },

    hideCommentAssetsMenu() {
      this.viewCommentAssetsMenu = false;
    },

    formSubmitted() {
      let vm = this;
      let formData = new FormData(vm.$refs.inspectionForm);
      let jsonObject = {};

      this.formSaveMessage = '';

      for(const[key, value] of formData.entries()) {
        jsonObject[key] = value;
      }
      
      let inspectionDataString = JSON.stringify(jsonObject);
      
      api.updateSubsection(this.sid, inspectionDataString)
        .then((res) => {
          if(res.status === 200) {
            this.inspectionData = res.data.checklist_json;
            this.formSaveMessage = 'Successfully Saved Inspection Summary.'
          }
        });
    }
  },

};
</script>


<style lang="scss">
@import '@/assets/sass/_variables.scss';


.sd-tools--topleft{
  position: absolute;
  top:5rem;
  left:1rem;
  z-index: 2;
}

.sd-tools__boxes{
  cursor: pointer;
  width: 2.6rem;
  height: 2.6rem;
  border-radius: .2rem;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.5);
}

.sd-tools__checklistoptns {
  position: absolute;
  left: 3rem;
  z-index: 2;
  width: 516px;
  border-radius: .2rem;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.5);
}

.sd-tools__mapfilteroptns{
  position: absolute;
  left: 3rem;
  z-index: 2;
  width: 266px;
  border-radius: .2rem;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.5);
}

.sd-tools__commentAssetsMenu{
  position: absolute;
  left: 3rem;
  // top: 9.3rem;
  z-index: 2;
  width: 310px;
  border-radius: .2rem;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.5);
}

.sd-tools__scrollMenu {
    overflow-y: auto;
    height: 275px;
    &::-webkit-scrollbar {
      width: 3px;
    }

    /* Track */
    &::-webkit-scrollbar-track {
      background: $gray-light;
    }

    /* Handle */
    &::-webkit-scrollbar-thumb {
      background: $gray;
      border-radius: 0.2rem;
    }

    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
      background: $gray-dark;
    }
  }

.sd-tools__maplayer {
  width: 3.5rem;
  height: 3.5rem;
  cursor: pointer;
  border-radius: .2rem;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.5);
}
.sd-tools__mlcontent {
  position: relative;
  float: left;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
// TODO: Update below png files after getting proper svg asset from designer
.sd-tools__ort{
  background: url('../assets/img/mainmap/map_layer_ort.png');
  background-size: auto;
  background-position: center;
}
.sd-tools__drw{
  background: url('../assets/img/mainmap/map_layer_drw.png');
  background-size: auto;
  background-position: center;
}
.sd-tools__dsm{
  background: url('../assets/img/mainmap/map_layer_dsm.png');
  background-size: auto;
  background-position: center;
}
.sd-tools--bottomleft{
  position: absolute;
  bottom:1rem;
  left:1rem;
  z-index: 2;
}

.sd-tools--bottomright {
  position: absolute;
  right: 0.8rem;
  bottom: 2rem;
  z-index: 2;
}

.sd-tools__circle {
  width: 2rem;
  height: 2rem;
  cursor: pointer;
  padding: .3rem;
  border-radius: 10rem;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.5);
}
.sd-toggle{
  margin-top:5px;
  margin-left:10px;
}
</style>
